<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <form-section :title="$t('Profiles_Title_LifecycleOverview')">
      <div class="block-container">
        <el-row>
          <el-col v-for="(item, index) in items" :key="index" :span="12">
            <span class="item-field-title">{{ item.label }}</span>
            <overflow-tooltip :value="formatValue(item)" />
          </el-col>
        </el-row>
      </div>
    </form-section>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import FormSection from '@/common/components/form/FormSection'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'
import { projectEndpoint, projectTimezoneDate } from '@/core/helpers'

export default {
  name: 'LifecycleOverview',

  components: {
    RestPage,
    FormSection,
    OverflowTooltip
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      model: {}
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `user-profiles/${this.profileId}`,
        params: {
          expand: 'aggregates,lifecycle_stage'
        },
        handler: data => {
          this.model = data['aggregates'] || {}
          this.model['lifecycle_stage'] = data['lifecycle_stage']
        }
      })
    },

    items() {
      return [
        {
          label: this.$t('LifecycleOverview_LifecycleStage'),
          value: this.model['lifecycle_stage']
        },
        {
          label: this.$t('LifecycleOverview_ValueTier'),
          value: this.model['value_tier']
        },
        {
          label: this.$t('LifecycleOverview_TotalPurchases'),
          value: this.model['total_purchases']
        },
        {
          label: this.$t('LifecycleOverview_TotalSpent'),
          value: this.model['total_spent'],
          isMoney: true
        },
        {
          label: this.$t('LifecycleOverview_FirstPurchaseDate'),
          value: this.model['first_purchase_date'],
          isDate: true
        },
        {
          label: this.$t('LifecycleOverview_LastPurchaseDate'),
          value: this.model['last_purchase_date'],
          isDate: true
        },
        {
          label: this.$t('LifecycleOverview_RegistrationDate'),
          value: this.model['registration_date'],
          isDate: true
        }
      ]
    }
  },

  methods: {
    formatValue(prop) {
      if (
        prop.value !== null &&
        prop.value !== undefined &&
        prop.value !== ''
      ) {
        if (prop.isDate) {
          return this.formatDate(prop.value)
        } else if (prop.isMoney) {
          return this.formatMoney(prop.value)
        } else {
          return prop.value
        }
      } else {
        return '-'
      }
    },

    formatDate(time, format = 'YYYY-MM-DD') {
      if (!time) {
        return '-'
      }

      return projectTimezoneDate(time).format(format)
    },

    formatMoney(value) {
      if (!value) {
        return '-'
      }

      return parseFloat(value).toFixed(2)
    }
  }
}
</script>

<style scoped>
.block-container {
  background-color: #f8fafc;
  padding: 20px 20px 0 20px;
}

.el-col.el-col-12 {
  margin-bottom: 20px;
}

.item-field-title {
  color: #a7acba;
  font-size: 14px;
  line-height: 22px;
}

>>> .label {
  font-size: 14px;
  line-height: 28px;
  color: #4b515f;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/LifecycleOverview.vue